export default __webpack_public_path__ + "static/media/100_19086.eecb8a64.jpg";